<!-- <ng-container *ngIf="loading">
    <ngx-spinner *ngIf="authentication.currentUserValue && currentUrl !== '/auth/sign-in'" bdColor="rgba(0, 0, 0, 1)"
        size="default" color="#C3434B" type="ball-clip-rotate-multiple" [fullScreen]="true">
        <p style="color: #C3434B"> Loading... </p>
    </ngx-spinner>
</ng-container> -->

<ng-container
  *ngIf="
    !showAppChrome &&
    showHeader() &&
    currentUrl !== '/welcome'
  "
>
  <app-auth-head></app-auth-head>
</ng-container>
<ng-container
  *ngIf="
    showAppChrome && showHeader() && currentUrl !== '/welcome'
  "
>
  <app-head-toolbar></app-head-toolbar>
</ng-container>
<section>
  <main>
    <p-toast
      [breakpoints]="{ '768px': { width: '100%', right: '0', left: '0' } }"
      position="bottom-right"
      key="br"
      styleClass="fixed-toast"
    ></p-toast>
    <router-outlet></router-outlet>
  </main>
</section>
<div class="feedback-fab" (click)="openFeedback()" *ngIf="
    showAppChrome && showHeader() && currentUrl !== '/welcome'
  ">
  <i class="pi pi-megaphone"></i>

  <span>Feedback</span>
</div>
<!-- Feedback Modal -->
<app-feedback-form *ngIf="showFeedback" (closeModal)="closeFeedback()">
</app-feedback-form>
<footer
  class="footer"
  *ngIf="
    showAppChrome && showHeader() && currentUrl !== '/welcome'
  "
>
  <div class="container">
    <div class="footer-content"></div>
    <div class="footer-bottom">
      <p class="text-primary">
        &copy; Copyright 2025, Designed & Developed by Augmented Transformations
        Pvt. Ltd.
      </p>
    </div>
  </div>
</footer>
